import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["overflowStrategy", "minFontSize", "maxFontSize", "forceFontSize"];
import { DomainWithEllipsis } from '../DomainWithEllipsis';
import React from 'react';
import { Box, Text } from '@wix/design-system';
import s from './DomainText.css';
const AVERAGE_GLYPH_WIDTH_RATIO = 0.58;
export const DomainText = _ref => {
  let _ref$overflowStrategy = _ref.overflowStrategy,
    overflowStrategy = _ref$overflowStrategy === void 0 ? 'ellipsis' : _ref$overflowStrategy,
    _ref$minFontSize = _ref.minFontSize,
    minFontSize = _ref$minFontSize === void 0 ? '1.125rem' : _ref$minFontSize,
    _ref$maxFontSize = _ref.maxFontSize,
    maxFontSize = _ref$maxFontSize === void 0 ? '1.75rem' : _ref$maxFontSize,
    forceFontSize = _ref.forceFontSize,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (overflowStrategy === 'ellipsis') {
    return /*#__PURE__*/React.createElement(DomainWithEllipsis, props);
  }
  const textComponent = props.textComponent,
    textComponentProps = props.textComponentProps,
    children = props.children,
    dataHook = props.dataHook,
    className = props.className,
    maxWidth = props.maxWidth;
  const Component = textComponent || Text;
  if (overflowStrategy === 'wrap') {
    return /*#__PURE__*/React.createElement(Box, {
      inline: true,
      maxWidth: maxWidth ?? '600px'
    }, /*#__PURE__*/React.createElement(Component, _extends({}, textComponentProps, {
      dataHook: dataHook,
      className: [s.wrap, className].filter(Boolean).join(' ')
    }), children));
  }
  const domainStr = (children == null ? void 0 : children.toString()) ?? '';
  const scaleStyle = {
    '--domain-scale': 1 / (AVERAGE_GLYPH_WIDTH_RATIO * (domainStr.length || 1)),
    '--domain-min-font-size': minFontSize,
    '--domain-max-font-size': maxFontSize,
    ...(forceFontSize && {
      '--domain-force-font-size': forceFontSize
    })
  };
  return /*#__PURE__*/React.createElement(Box, {
    display: "inline",
    style: scaleStyle
  }, /*#__PURE__*/React.createElement(Component, _extends({}, textComponentProps, {
    dataHook: dataHook,
    className: [s.autoScale, className].filter(Boolean).join(' ')
  }), children));
};
//# sourceMappingURL=DomainText.js.map